import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { log } from 'core/utilities';
import TagManager from 'react-gtm-module';

const env = process.env.REACT_APP_NODE_ENV;

const tagManagerArgs = {
    gtmId: 'GTM-TB83L2Q',
    //the below changes GTM values based on whether staging or production
    auth: env === 'production'
        ? 'l5DkHPzR_k46PYVyN1Hshw'
        : 'oNx-2a-z5y97LHCQ4XwaXg',
    preview: env === 'production'
        ? 'env-2'
        : 'env-51'
};

TagManager.initialize(tagManagerArgs);

ReactDOM.render(
    <App />,
    document.getElementById('root')
);

reportWebVitals(log.webVitals);